import { render, staticRenderFns } from "./BirdSalesWidget.vue?vue&type=template&id=5f766812&scoped=true&"
import script from "./BirdSalesWidget.vue?vue&type=script&lang=js&"
export * from "./BirdSalesWidget.vue?vue&type=script&lang=js&"
import style0 from "./BirdSalesWidget.vue?vue&type=style&index=0&id=5f766812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f766812",
  null
  
)

export default component.exports